/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Tab_AccountInputs */



/**
* | output |
* | --- |
* | "Account" |
*
* @param {Profile_Tab_AccountInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_tab_account = /** @type {((inputs?: Profile_Tab_AccountInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Tab_AccountInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Compte")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cuenta")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Conta")
	if (locale === "it") return /** @type {LocalizedString} */ ("Account")
	return /** @type {LocalizedString} */ ("Account")
});